export enum GroupMembersTableColumnEnum {
    MEMBERS = 1,
    EMAIL = 2,
    ROLE = 3,
    INTERNAL_EXTERNAL = 4,
    ACTIONS,
}

export const groupMembersTableColumnText: Record<GroupMembersTableColumnEnum, string> = {
    [GroupMembersTableColumnEnum.MEMBERS]: 'group.members.table.header.members',
    [GroupMembersTableColumnEnum.EMAIL]: 'group.members.table.header.email',
    [GroupMembersTableColumnEnum.ROLE]: 'group.members.table.header.role',
    [GroupMembersTableColumnEnum.INTERNAL_EXTERNAL]: 'group.members.table.header.InternalExternal',
    [GroupMembersTableColumnEnum.ACTIONS]: '',
};
